import { motion } from "framer-motion";
import { Target, BarChart3 } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
};

export const AboutSection = () => {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative py-24 lg:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Image */}
          <motion.div
            {...fadeInUp}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-[#2563EB]/10 rounded-2xl blur-[40px]" />
              <div className="relative glass-card rounded-2xl overflow-hidden border border-white/10">
                <img
                  src="https://images.pexels.com/photos/7648046/pexels-photo-7648046.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt="Equipe Andiaras em reunião estratégica"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/80 via-transparent to-transparent" />
              </div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            {...fadeInUp}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-7"
          >
            <span className="font-outfit uppercase tracking-[0.2em] text-xs font-semibold text-[#2563EB] mb-4 block">
              Sobre Nós
            </span>
            <h2 className="font-outfit font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6 leading-tight">
              Andiaras Gestão & Performance
            </h2>
            <p className="text-[#A1A1AA] text-lg leading-relaxed mb-6">
              A Andiaras Gestão & Performance é especializada em gerar crescimento
              para empresas locais através de estratégias avançadas de{" "}
              <span className="text-white font-medium">
                tráfego pago, posicionamento e conversão.
              </span>
            </p>
            <p className="text-[#A1A1AA] text-lg leading-relaxed mb-10">
              Nosso foco é{" "}
              <span className="text-[#10B981] font-medium">
                transformar investimento em marketing em resultados reais
              </span>
              . Trabalhamos com empresas que querem crescer de forma previsível e
              sustentável.
            </p>

            {/* Stats or Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl icon-container flex items-center justify-center flex-shrink-0">
                  <Target className="w-6 h-6 text-[#2563EB]" />
                </div>
                <div>
                  <h4 className="font-outfit font-semibold text-white mb-1">
                    Foco em Resultado
                  </h4>
                  <p className="text-[#A1A1AA] text-sm">
                    Cada ação é orientada para gerar retorno mensurável.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl icon-container flex items-center justify-center flex-shrink-0">
                  <BarChart3 className="w-6 h-6 text-[#2563EB]" />
                </div>
                <div>
                  <h4 className="font-outfit font-semibold text-white mb-1">
                    Decisões Baseadas em Dados
                  </h4>
                  <p className="text-[#A1A1AA] text-sm">
                    Análise contínua para otimizar performance.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
